import { Typography, Tooltip, Dropdown, Tag } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { ENT_STATUS, BTN_TXT, ENT_STATUS_DISPLAY_NAMES } from "../../../constants/constants";
import { PERM_CODE } from "../../../constants/PermissionCodes";
import { safeStringSort } from "../../../helpers/sortHelpers";

const { Text } = Typography;

export const getEnterpriseColumns = ({
  onApprove,
  onUploadDocs,
  onDeactivate,
  onBlacklist,
  onActivate,
  onView,
  status,
  privileges }) => {
  const columns = [
    {
      title: "Enterprise Name",
      dataIndex: "entName",
      key: "entName",
      width: 200,
      sorter: (a, b) => safeStringSort(a?.entName, b?.entName),
      fixed: "left" },
    {
      title: "Contact Name",
      dataIndex: "pocName",
      key: "pocName",
      width: 180,
      sorter: (a, b) => safeStringSort(a?.pocName, b?.pocName),
      render: (text) => text || "N/A" },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      width: 180,
      sorter: (a, b) => safeStringSort(a?.phoneNumber, b?.phoneNumber),
      render: (text) => text || "N/A" },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
      sorter: (a, b) => safeStringSort(a?.email, b?.email),
      render: (text) => text || "N/A" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 130,
      sorter: (a, b) => {
        const statusA = a?.statusName || ENT_STATUS_DISPLAY_NAMES?.[a?.statusId] || "";
        const statusB = b?.statusName || ENT_STATUS_DISPLAY_NAMES?.[b?.statusId] || "";
        return safeStringSort(statusA, statusB);
      },
      render: (_, record) => {
        const statusText =
          record?.statusName ||
          ENT_STATUS_DISPLAY_NAMES?.[record?.statusId] ||
          record?.statusId ||
          "N/A";
        return <Tag color="blue">{statusText}</Tag>;
      } },
    {
      title: "Designation",
      dataIndex: "designationName",
      key: "designationName",
      width: 180,
      sorter: (a, b) => safeStringSort(a?.designationName, b?.designationName),
      render: (text) => text || "N/A" },
    {
      title: "Industry",
      dataIndex: "industryTypeName",
      key: "industryTypeName",
      width: 180,
      sorter: (a, b) => safeStringSort(a?.industryTypeName, b?.industryTypeName),
      render: (text) => text || "N/A" },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      width: 200,
      sorter: (a, b) => safeStringSort(a?.comments, b?.comments),
      render: (text) =>
        text ? (
          <Tooltip title={text}>
            <Text ellipsis style={{ maxWidth: 180, display: "block" }}>
              {text}
            </Text>
          </Tooltip>
        ) : (
          "N/A"
        ) },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      fixed: "right",
      render: (_, record) => {
        const items = [];
        const rowStatus =
          record?.statusId ||
          (Array.isArray(status) ? (status.length === 1 ? status[0] : null) : status);

        // View
        if (
          rowStatus === ENT_STATUS.ACTIVE.ID ||
          rowStatus === ENT_STATUS.DEACTIVATED.ID ||
          rowStatus === ENT_STATUS.BLACKLISTED?.ID ||
          rowStatus === ENT_STATUS.PENDING.ID ||
          (!rowStatus && Array.isArray(status) && status.length > 0)
        ) {
          items.push({
            key: "view",
            label: "View",
            onClick: () => onView?.(record.entId) });
        }

        // Pending → Approve
        if (
          rowStatus === ENT_STATUS.PENDING.ID &&
          privileges?.includes(PERM_CODE.EPSAC)
        ) {
          items.push({
            key: "approve",
            label: BTN_TXT.APPROVE,
            onClick: () => onApprove(record) });
        }

        // Active → Deactivate
        if (
          rowStatus === ENT_STATUS.ACTIVE.ID &&
          privileges?.includes(PERM_CODE.EVSDE)
        ) {
          items.push({
            key: "deactivate",
            label: BTN_TXT.DEACTIVATE,
            onClick: () => onDeactivate(record) });
        }

        // Active → Blacklist
        if (
          rowStatus === ENT_STATUS.ACTIVE.ID &&
          privileges?.includes(PERM_CODE.EVSBL)
        ) {
          items.push({
            key: "blacklist",
            label: BTN_TXT.BLACKLIST,
            onClick: () => onBlacklist(record) });
        }

        // Deactivated → Reactivate
        if (
          rowStatus === ENT_STATUS.DEACTIVATED.ID &&
          privileges?.includes(PERM_CODE.EDSRE)
        ) {
          items.push({
            key: "reactivate",
            label: BTN_TXT.REACTIVATE,
            onClick: () => onActivate(record) });
        }

        if (!items.length) return null;

        return (
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <MoreOutlined
              style={{
                fontSize: "20px",
                cursor: "pointer" }}
            />
          </Dropdown>
        );
      } }
  ];

  return columns;
};
